// extracted by mini-css-extract-plugin
module.exports = {"BannerWarp":"Banner_BannerWarp__2IJKt","auto":"Banner_auto__19IAo"};